import { MatxLoadable } from "matx";

const AppSnackbar = MatxLoadable({
  loader: () => import("./snackbar/AppSnackbar"),
});
const AppDialog = MatxLoadable({
  loader: () => import("./dialog/AppDialog"),
});
const AppExpansionPanel = MatxLoadable({
  loader: () => import("./expansion-panel/AppExpansionPanel"),
});
const AppAutoComplete = MatxLoadable({
  loader: () => import("./auto-complete/AppAutoComplete"),
});
const AppSlider = MatxLoadable({
  loader: () => import("./slider/AppSlider"),
});
const AppRadio = MatxLoadable({
  loader: () => import("./radio/AppRadio"),
});
const AppSwitch = MatxLoadable({
  loader: () => import("./switch/AppSwitch"),
});
const AppCheckbox = MatxLoadable({
  loader: () => import("./checkbox/AppCheckbox"),
});
const AppMenu = MatxLoadable({
  loader: () => import("./menu/AppMenu"),
});
const AppProgress = MatxLoadable({
  loader: () => import("./AppProgress"),
});
const AppIcon = MatxLoadable({
  loader: () => import("./icons/AppIcon"),
});
const AppButton = MatxLoadable({
  loader: () => import("./buttons/AppButton"),
});
const AppForm = MatxLoadable({
  loader: () => import("./forms/AppForm"),
});
const AppTable = MatxLoadable({
  loader: () => import("./tables/AppTable"),
});

const materialRoutes = [
  {
    path: "/material/table",
    component: AppTable,
    permission: ["manager", "customer_service"],
  },
  {
    path: "/material/form",
    component: AppForm,
    permission: ["manager", "customer_service"],
  },
  {
    path: "/material/buttons",
    component: AppButton,
    permission: ["manager", "customer_service"],
  },
  {
    path: "/material/icons",
    component: AppIcon,
    permission: ["manager", "customer_service"],
  },
  {
    path: "/material/progress",
    component: AppProgress,
    permission: ["manager", "customer_service"],
  },
  {
    path: "/material/menu",
    component: AppMenu,
    permission: ["manager", "customer_service"],
  },
  {
    path: "/material/checkbox",
    component: AppCheckbox,
    permission: ["manager", "customer_service"],
  },
  {
    path: "/material/switch",
    component: AppSwitch,
    permission: ["manager", "customer_service"],
  },
  {
    path: "/material/radio",
    component: AppRadio,
  },
  {
    path: "/material/slider",
    component: AppSlider,
    permission: ["manager", "customer_service"],
  },
  {
    path: "/material/autocomplete",
    component: AppAutoComplete,
    permission: ["manager", "customer_service"],
  },
  {
    path: "/material/expansion-panel",
    component: AppExpansionPanel,
    permission: ["manager", "customer_service"],
  },
  {
    path: "/material/dialog",
    component: AppDialog,
    permission: ["manager", "customer_service"],
  },
  {
    path: "/material/snackbar",
    component: AppSnackbar,
    permission: ["manager", "customer_service"],
  },
];

export default materialRoutes;
